import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=c8c71794&scoped=true&"
import script from "./activity.ts?vue&type=script&lang=js&"
export * from "./activity.ts?vue&type=script&lang=js&"
import style0 from "./activity.less?vue&type=style&index=0&id=c8c71794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c71794",
  null
  
)

export default component.exports